//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CancelCampaignModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    create: {
      type: Boolean,
      default: true
    },
    scheduledDate: {
      type: String,
      default: ""
    },
    scheduledTime: {
      type: String,
      default: ""
    },
    canceling: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    date() {
      return moment(this.scheduledDate + " " + this.scheduledTime);
    },
    isPastDate() {
      const now = moment();
      return now >= this.date;
    }
  },
  methods: {
    showModal() {
      this.$refs.cancelCampaign.show();
    },
    closeModal() {
      this.$refs.cancelCampaign.hide();
    },
    handleSubmit() {
      this.$emit("submit");
    }
  }
});